module.exports = __webpack_public_path__ + "static/media/fitnes-wensyydt26.a042fdc0.png";